/***** body addclass *****/
  $(document).ready(function(){
    var loc = location.pathname.split('/');
    var locclr = loc.filter(Boolean);
    var dirName = locclr[locclr.length -1];
    console.log(dirName);
    if ( locclr.length === 0 || dirName === 'en' || dirName === 'fr' || dirName === 'ko' || dirName === 'zh' ){
        $('body').addClass('top');
    } else {
        $('body').addClass(dirName);
    }

    /* anyclass */ 
      if ( dirName === 'shoppingguide-commmonsmart' || dirName === 'users-guide' || dirName === 'pages-users-guide' || dirName === 'faq' || dirName === 'contact' ){
        $('body').addClass('about');
      }
      if ( dirName === 'refund-policy' || dirName === 'shipping-policy' || dirName === 'terms-of-service' || dirName === 'privacy-policy' || dirName === 'ccpa-opt-out' || dirName === 'legal-notice' ){
        $('body').addClass('about policy');
      }
    /* /anyclass */

  });

  $(document).ready(function(){
    $('div.mobile-nav__has-sublist').addClass('mobile-nav--expanded');
  });
/***** /body addclass *****/





/***** div addclass *****/
  $(document).ready(function(){
    /* SHOP ID */
      const shopId = '#shopify-section-template--20486964052192__';
      const shopheaderId = '#shopify-section-sections--20486963232992__';
      const shopfooterId = '#shopify-section-sections--20486963200224__';
      const shopcollectionId = '#shopify-section-template--20486964379872__';
      // const shopproductId = '#shopify-section-template--17854860230874__';
    /* /SHOP ID */
  
    /* top nav */  
      $(shopheaderId + 'header').addClass('ghead');
    /* /top nav */
    
    /* top nav */
      $(shopId + 'advanced_layout_custom_liquid_KjJWwp').addClass('top_nav');
    /* /top nav */
    
    /* top hero */
      $(shopId + 'image_slideshow_NnyLeg').addClass('top_hero');
    /* /top hero */
    
    /* top artist */
      $(shopId + 'advanced_layout_custom_liquid_CCYFkE').addClass('top_art');
    /* /top artist */
    
    /* top collection */
      $(shopId + 'collection_featured_collection_jdGTrB').addClass('collection_wrapper');
      $(shopId + 'collection_featured_collection_fANHJN').addClass('collection_wrapper');
      $(shopId + 'collection_featured_collection_tTVEgf').addClass('collection_wrapper');
      $(shopId + 'collection_featured_collection_LLMFER').addClass('collection_wrapper');
    /* /top collection */
    
    /* collection collection */
      $(shopcollectionId + 'product-grid').addClass('collection_wrapper');
      $(shopcollectionId + 'advanced_layout_custom_liquid_a3wXTV > div').addClass('collection_wrapper');
    /* /collection collection */

    /* other wrapper */
      $(shopId + 'advanced_layout_custom_liquid_eyRcHn').addClass('other_wrapper');
      $(shopId + 'advanced_layout_custom_liquid_xVnH7Y').addClass('other_wrapper');
    /* /other wrapper */

    /* footer */
      $(shopfooterId + 'footer-main').addClass('fmain');
      $(shopfooterId + 'footer-bottom').addClass('fbottom');
    /* /footer */
  });
/***** /div addclass *****/





/***** products scroll hide *****/
  $(document).ready(function() {
    if (window.matchMedia("(max-width: 768px)").matches) {
      var pageTop = $('body.template-product .breadcrumb, body.template-product .site-nav--mobile, body.template-product ul.site-header__links li:nth-of-type(2)');
      var pageTopps = $('body.template-product .breadcrumb, body.template-product .site-nav--mobile, body.template-product ul.site-header__links li:nth-of-type(2)').offset();
      pageTop.hide();
      $(window).on("scroll touchmove", function () {
        pageTop.stop();
        pageTop.fadeOut();
        if ($(this).scrollTop() > 300) {
          pageTop.stop();
          pageTop.hide().delay(300).fadeIn('fast');
        }
      });
    }
  });
/***** /products scroll hide *****/

/***** accordion *****/
  document.addEventListener('click', (event) => {
    let title = event.target.closest('.acdn_btn');
    if( title ) {
      let item = title.closest('.acdn');
      let panel = item.querySelector('.acdn_btn');
      panel.classList.toggle('acdn_show');
    }
  });
/***** /accordion *****/